module.exports = __webpack_public_path__ + "img/sup_deposit_crypto3.f4188aa5.jpg";